// App.js
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Metrics from './pages/Metrics';
import Admin from './pages/Admin';
import Stocks from './pages/Stocks';
import Sidebar from './components/Sidebar';

function App() {
    return (
        <Router>
            <MainApp />
        </Router>
    );
}

function MainApp() {
    const location = useLocation();
    const showSidebar = location.pathname !== "/";

    return (
        <div className="app-container">
            {showSidebar && <Sidebar />}
            <div className="content">
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/metrics" element={<Metrics />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/stocks" element={<Stocks />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </div>
        </div>
    );
}

export default App;
